import React from 'react';
import { Sparkles } from 'lucide-react';
import { useAgent } from '../AgentProvider';

const isMac = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent || '');

function AgentLauncher() {
  const agent = useAgent();
  if (!agent?.enabled || agent.open) return null;

  return (
    <button type="button" className="dagent-launcher" onClick={() => agent.openAgent()} title={`Ask Dridh Agent (${isMac ? 'Cmd' : 'Ctrl'} + J)`}>
      <Sparkles size={17} aria-hidden="true" />
      <span>Ask agent</span>
      <kbd>{isMac ? '⌘J' : 'Ctrl J'}</kbd>
    </button>
  );
}

export default AgentLauncher;
